var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNauseaSliderIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 113.39 113.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-nausea-slider,.cls-2-nausea-slider{fill:none;stroke:#fff;stroke-width:3px;}.cls-1-nausea-slider{stroke-miterlimit:10;}.cls-2-nausea-slider{stroke-linecap:round;stroke-linejoin:round;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1-nausea-slider",
    cx: 57.56,
    cy: 57.47,
    r: 42.19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2-nausea-slider",
    x1: 48.19,
    y1: 76.41,
    x2: 67.88,
    y2: 76.41
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-nausea-slider",
    d: "M35.45,43.44s2.75-2.16,8.1-1.75c5,.37,6.92,2.88,6.92,2.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-nausea-slider",
    d: "M67,37.9s1,3.36,5.54,6.15c4.25,2.59,7.32,1.7,7.32,1.7"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2-nausea-slider",
    cx: 43.06,
    cy: 55.25,
    rx: 4.92,
    ry: 3.89
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2-nausea-slider",
    cx: 72.22,
    cy: 55.25,
    rx: 4.92,
    ry: 3.89
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNauseaSliderIcon2);
export default __webpack_public_path__ + "static/media/nausea_slider_icon_2.9a3755f8.svg";
export { ForwardRef as ReactComponent };